module.exports = __webpack_public_path__ + "img/symbol_11.9bd6ee14.png";